"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactComponents = require("@cimpress/react-components");
var _DisplayContext = require("./contexts/DisplayContext");
var _react2 = require("@emotion/react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var AccordionWrapper = function AccordionWrapper(props) {
  var _useContext = (0, _react.useContext)(_DisplayContext.DisplayContext),
    showCondensedView = _useContext.showCondensedView;
  return (0, _react2.jsx)(_reactComponents.Accordion, (0, _extends2["default"])({
    style: {
      margin: 0
    },
    headerStyle: {
      padding: 0,
      fontSize: showCondensedView ? '13px' : undefined
    },
    bodyStyle: {
      paddingBottom: 0
    }
  }, props));
};
var _default = exports["default"] = AccordionWrapper;